import { ListA2ATransactionsData } from '@dock/types-dock-partner';

export const getAccountIds = (list: ListA2ATransactionsData): string[] =>
    list.map((el) => el.counterparty.accountId);
